// extracted by mini-css-extract-plugin
export default {"layoutComponent":"PlatformSelector_layoutComponent__bjKrW","layoutComponent_Content":"PlatformSelector_layoutComponent_Content__IPxrv"};